import { useEffect } from "react";

import {
  Accordion,
  AccordionActions,
  AccordionSummary,
  AccordionDetails,
  Box,
  Button,
  Stack,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import useLocalization from "../../hooks/useLocalization";

import InfoBox from "../layout/InfoBox";
import AvailabilityDisplay from "./AvailabilityDisplay";
import ControlledByDisplay from "./ControlledByDisplay";
import MatrixItemsDisplay from "./MatrixItemsDisplay";
import SkuMatrixDisplay from "./SkuMatrixDisplay";
import VisibilityDisplay from "./VisibilityDisplay";
import HTMLDisplay from "./HTMLDisplay";

const SurveySection = ({
  surveyId,
  pageIndex,
  pageId,
  section,
  sectionIndex,
  expanded,
  onExpand,
  onEdit,
}) => {
  const theme = useTheme();

  const { getLabel, getMessage, sectionTypeLabel } = useLocalization();

  useEffect(() => {
    // console.log({ section, expanded });
  }, []);

  if (!section) return null;

  return (
    <Accordion
      onChange={(e, isExpanded) => onExpand(sectionIndex, isExpanded)}
      expanded={expanded}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          backgroundColor: expanded
            ? theme.palette.primary.dark
            : theme.palette.primary.light,
        }}
      >
        <Box sx={{ width: "300px", whiteSpace: "wrap" }}>{section.name}</Box>
      </AccordionSummary>
      <AccordionDetails sx={{ border: "1px solid #ccc" }}>
        <Stack
          spacing={1}
          sx={{ width: "300px" }}
        >
          <InfoBox label={getLabel("name_fr")}>
            {section.name_fr ? section.name_fr : getMessage("notSet")}
          </InfoBox>

          <InfoBox label={getLabel("type")}>
            {sectionTypeLabel(section.sectionType)}
          </InfoBox>

          <InfoBox label={getLabel("active")}>
            {section.isActive ? "True" : "False"}
          </InfoBox>

          <InfoBox label={getLabel("controlledBy")}>
            <ControlledByDisplay
              value={section.controlledBy}
              pageIndex={pageIndex}
              sectionIndex={sectionIndex}
              surveyId={surveyId}
            />
          </InfoBox>

          <InfoBox label={getLabel("availability")}>
            <AvailabilityDisplay
              value={section.availability}
              emptyMessage={getMessage("basedOnPage")}
            />
          </InfoBox>

          <InfoBox label={getLabel("visibility")}>
            <VisibilityDisplay value={section.visibility} />
          </InfoBox>

          {section.sectionType === "matrix" ? (
            <InfoBox label={getLabel("matrixItems")}>
              <MatrixItemsDisplay matrixItems={section?.matrixItems} />
            </InfoBox>
          ) : null}

          {section.sectionType === "sku" ? (
            <InfoBox label={getLabel("skuMatrix")}>
              <SkuMatrixDisplay skuMatrix={section?.skuMatrix} />
            </InfoBox>
          ) : null}
        </Stack>
      </AccordionDetails>

      <AccordionActions>
        <Button
          onClick={() => onEdit(sectionIndex)}
          variant="contained"
          size="small"
        >
          {getLabel("edit")}
        </Button>
      </AccordionActions>
    </Accordion>
  );
};

export default SurveySection;
